<template>
  <re-select
    v-model="selectedRoles"
    filled
    multiple
    hide-dropdown-icon
    :option-disable="(item: string) => (props.unremovable.includes(item) ? true : false)"
    use-input
    use-chips
    stack-label
    :readonly="!props.editable"
    :options="options"
    class="admin-role-select"
    bg-color="light"
    hide-bottom-space
    @filter="filterOptions"
  />
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue'

import enums from '@/plugins/enums'

const props = defineProps({
  roles: { type: Array, required: true },
  editable: { type: Boolean, default: false },
  unremovable: { type: Array, default: () => [] },
})
const emit = defineEmits(['select-role'])
const staticRoles = enums.roles
const options = ref(staticRoles)

const selectedRoles = ref(props.roles)
const unselectedRoles = computed(() => {
  return staticRoles.filter(r => !selectedRoles.value.includes(r))
})
function filterOptions(val: string, update: (fn: () => void) => void) {
  if (val === '') {
    update(() => {
      options.value = staticRoles.filter(r => !selectedRoles.value.includes(r))
    })
    return
  }

  update(() => {
    const needle = val.toLowerCase()
    options.value = unselectedRoles.value.filter(v => v.toLowerCase().includes(needle))
  })
}

watch(selectedRoles, (roles) => {
  options.value = options.value.filter(r => !roles.includes(r))
  emit('select-role', roles)
})
</script>

<style lang="scss" scoped>
.admin-role-select {
  max-width: 15rem;
}
</style>
